import _inherits from "/app/node_modules/.pnpm/next@13.5.3_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _setPrototypeOf from "/app/node_modules/.pnpm/next@13.5.3_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/setPrototypeOf.js";

function _wrapRegExp() { _wrapRegExp = function _wrapRegExp(re, groups) { return new BabelRegExp(re, void 0, groups); }; var _super = RegExp.prototype, _groups = new WeakMap(); function BabelRegExp(re, flags, groups) { var _this = new RegExp(re, flags); return _groups.set(_this, groups || _groups.get(re)), _setPrototypeOf(_this, BabelRegExp.prototype); } function buildGroups(result, re) { var g = _groups.get(re); return Object.keys(g).reduce(function (groups, name) { return groups[name] = result[g[name]], groups; }, Object.create(null)); } return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (str) { var result = _super.exec.call(this, str); return result && (result.groups = buildGroups(result, this)), result; }, BabelRegExp.prototype[Symbol.replace] = function (str, substitution) { if ("string" == typeof substitution) { var groups = _groups.get(this); return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) { return "$" + groups[name]; })); } if ("function" == typeof substitution) { var _this = this; return _super[Symbol.replace].call(this, str, function () { var args = arguments; return "object" != typeof args[args.length - 1] && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args); }); } return _super[Symbol.replace].call(this, str, substitution); }, _wrapRegExp.apply(this, arguments); }

import { snakeCase as lodashSnakeCase, camelCase as lodashCamelCase } from 'lodash';

const truncateString = (text, length) => text.length > length ? "".concat(text.substring(0, length), "...") : text;

const truncateFilename = (filename, length) => {
  const match = filename.match( /*#__PURE__*/_wrapRegExp(/(^.*)\.(.*)/, {
    name: 1,
    extension: 2
  }));
  if (!(match !== null && match !== void 0 && match.groups)) return truncateString(filename, length);
  const {
    name,
    extension
  } = match.groups;
  return "".concat(truncateString(name, length), ".").concat(extension);
}; // modified version of lodash 'snakeCase' function
// - doesn't change dots with underscores
// - doesn't add underscores before numbers


const snakeCase = field => {
  return field.split('.').map(part => lodashSnakeCase(part).replace(/_(\d+)(_|$)/g, '$1$2')).join('.');
};

const camelCase = field => {
  return field.split('.').map(part => lodashCamelCase(part)).join('.');
};

const isLetter = symbol => typeof symbol === 'string' ? /^[A-Za-z]+$/.test(symbol) : false;

const falselyStrings = ['0', 'f', 'F', 'false', 'FALSE', 'off', 'OFF'];

const isStringTruthy = value => typeof value === 'string' && !falselyStrings.includes(value); // fallback for the Edge 18


const stringToBinary = value => {
  if (typeof TextEncoder === 'undefined') {
    return new Uint8Array(value.split('').map(character => character.charCodeAt(0)));
  }

  return new TextEncoder().encode(value);
};

export { truncateString, truncateFilename, snakeCase, camelCase, isLetter, isStringTruthy, stringToBinary };